const bindingTypes = [
  {
    attribute: "x-bind:text",
    update: (target, value) => {
      target.textContent = value
    }
  },
  {
    attribute: "x-bind:placeholder",
    update: (target, value) => {
      target.setAttribute("placeholder", value)
    }
  }
]

function bindingScope(source) {
  return source.closest("form") || document
}

function bindingSelector(attribute, name) {
  return `[${attribute.replace(":", "\\:")}="${CSS.escape(name)}"]`
}

function updateBindings(source) {
  const name = source.getAttribute("x-data")
  if (!name) return

  bindingTypes.forEach(({ attribute, update }) => {
    bindingScope(source).querySelectorAll(bindingSelector(attribute, name)).forEach((target) => {
      const value = source.value || target.getAttribute("x-default") || ""
      update(target, value)
    })
  })
}

function initializeXBind(root = document) {
  const sources = []

  if (root.matches?.("[x-data]")) sources.push(root)
  root.querySelectorAll?.("[x-data]").forEach((source) => sources.push(source))
  sources.forEach(updateBindings)
}

function updateFromEvent(event) {
  if (event.target.matches?.("[x-data]")) updateBindings(event.target)
}

document.addEventListener("input", updateFromEvent)
document.addEventListener("change", updateFromEvent)
document.addEventListener("blur", updateFromEvent, true)
document.addEventListener("DOMContentLoaded", () => initializeXBind())
document.addEventListener("turbo:load", () => initializeXBind())
document.addEventListener("turbo:render", () => initializeXBind())
document.addEventListener("nested-form:added", (event) => initializeXBind(event.target))
